import Modal from 'components/Modal'
import CreditAllocationTx from 'views/MemberProfile/ManualTx/CreditAllocationTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalCreditAllocationTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <CreditAllocationTx onClose={onClose} />
    </Modal>
  )
}

export default ModalCreditAllocationTx
